// DateDivider.jsx
const DateDivider = ({ label }) => (
  <div className="flex items-center gap-3 my-3 px-2">
    <div className="flex-1 h-px bg-slate-200" />
    <span className="text-xs font-medium text-slate-400 whitespace-nowrap">{label}</span>
    <div className="flex-1 h-px bg-slate-200" />
  </div>
)

export default DateDivider
